import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { DashboardProjectRow } from '../../services/onboardingTransforms';

export type IProject = DashboardProjectRow;
export interface IUserProject {
  currentProject: IProject;
  projectList: IProject[];
  currentRunId: number | null;
}

const initState: IUserProject = {
  currentProject: {
    project_id: -1,
    project_name: '',
    project_start_date: '',
    client_org_name: '',
  },
  projectList: [],
  currentRunId: null,
};

export const userProjectSlice = createSlice({
  name: 'userProject',
  initialState: initState,
  reducers: {
    setCurrentProject: (state: IUserProject, action: PayloadAction<IProject>) => {
      const prevId = state.currentProject.project_id;
      state.currentProject = action.payload;
      if (prevId !== action.payload.project_id) {
        state.currentRunId = null;
      }
    },
    setProjectAndRun: (
      state: IUserProject,
      action: PayloadAction<{ project: IProject; runId: number | null }>
    ) => {
      state.currentProject = action.payload.project;
      state.currentRunId = action.payload.runId;
    },
    setProjectList: (state: IUserProject, action: PayloadAction<IProject[]>) => {
      state.projectList = action.payload;
    },
    setCurrentRun: (state: IUserProject, action: PayloadAction<number | null>) => {
      state.currentRunId = action.payload;
    },
    resetUserProjectScope: (state: IUserProject) => {
      state.currentProject = initState.currentProject;
      state.currentRunId = null;
      state.projectList = [];
    },
  },
});

export const {
  setCurrentProject,
  setProjectAndRun,
  setProjectList,
  setCurrentRun,
  resetUserProjectScope,
} = userProjectSlice.actions;
export default userProjectSlice.reducer;
